<template>
    <!-- 院校管理 -->
    <div class="page">
        <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
            <div class="table-search-box table-search-box-hander">
                <el-form :inline="true" :model="searchData" class="demo-form-inline">
                    <!-- 防止输入框回车刷新页面 -->
                    <el-form-item label="" v-show="false">
                        <el-input></el-input>
                    </el-form-item>
                    <el-form-item label="院校名称：">
                        <el-input
                            size="small"
                            v-model="searchData.name"
                            placeholder="请输入院校名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="search_button">
                            <i class="pointer el-icon-search" @click="search()"></i>
                            <i class="pointer el-icon-refresh-left" @click="reset"></i>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="addition">
                    <el-button @click="add">
                        添加
                        <i class="h_icon icon-add"></i>
                    </el-button>
                </div>
            </div>

            <div class="table_box">
                <el-table :data="tableObj.list" style="width: 100%">
                    <el-table-column prop="index" label="序号" align="center"> </el-table-column>
                    <el-table-column prop="name" label="学校名称" align="center"> </el-table-column>
                    <el-table-column prop="year" label="年份" align="center"> </el-table-column>
                    <el-table-column prop="provice" label="省份" align="center"> </el-table-column>
                    <el-table-column prop="cityName" label="城市名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
                            <i
                                class="icona icon-delete"
                                title="删除"
                                @click="cutOut(scope.row.id)"
                            ></i>
                        </template>
                    </el-table-column>
                </el-table>
                <pageNumber
                    :paginations="7"
                    :pageNum="searchData.pageDto.pageNum"
                    :pageSize="searchData.pageDto.pageSize"
                    :total="tableObj.total"
                    :jumpTo="tableObj.jumpTo"
                    @currentChange="search"
                ></pageNumber>
            </div>
        </div>

        <!-- 添加弹窗 -->
        <el-dialog
            :title="uploadBox.title"
            :visible.sync="uploadBox.show"
            :close-on-click-modal="false"
            width="600px"
            class="pop_up"
            append-to-body
            :before-close="handleClose"
            @opened="opened"
        >
            <el-form
                ref="uploadBox"
                :model="uploadBox.data"
                :rules="uploadBox.rules"
                label-width="95px"
            >
                <!-- <el-form-item label="学校名称：" prop="name" required>
                    <el-input
                        size="small"
                        v-model="uploadBox.data.name"
                        placeholder="请输入。。。"
                    ></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="description" required>
                    <el-input
                        size="small"
                        type="textarea"
                        v-model="uploadBox.data.description"
                        placeholder="请输入。。。"
                    ></el-input>
                </el-form-item>
                <el-form-item label="是否启用：" prop="status" required>
                    <el-radio-group v-model="uploadBox.data.status">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item
                    v-for="(item, index) in formItemGroup"
                    :key="index"
                    :label="item.label"
                    :prop="item.prop"
                >
                    <el-input
                        v-if="item.option === 'input'"
                        size="small"
                        v-model="uploadBox.data[item.prop]"
                        :placeholder="item.placeholder"
                    ></el-input>
                    <el-input
                        v-if="item.option === 'textarea'"
                        size="small"
                        type="textarea"
                        v-model="uploadBox.data[item.prop]"
                        :placeholder="item.placeholder"
                    ></el-input>
                    <el-date-picker
                        v-if="item.option === 'yeartime'"
                        size="small"
                        type="year"
                        :placeholder="item.placeholder"
                        v-model="uploadBox.data[item.prop]"
                        :clearable="false"
                        style="width: 100%"
                        value-format="yyyy"
                        popper-class="dateClass"
                    ></el-date-picker>
                    <el-select
                        v-if="item.option === 'select'"
                        v-model="uploadBox.data[item.prop]"
                        :placeholder="item.placeholder"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        filterable
                    >
                        <el-option
                            v-for="(obj, i) in item.selectList"
                            :key="i"
                            :label="obj"
                            :value="obj"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="tx-center">
                <el-button size="small" @click="submitUpload">确定</el-button>
                <el-button size="small" @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
    components: {
        pageNumber,
    },
    data() {
        return {
            // 查询条件
            searchData: {
                name: "",
                pageDto: {
                    pageNum: 1, //当前显示的页面页码数
                    pageSize: 10,
                },
            },
            // 表格数据
            tableObj: {
                total: 0,
                jumpTo: 1,
                list: [],
            },
            optId: "", //判断当前是修改还是新增操作  1-新增；2-修改
            // 新增弹窗
            uploadBox: {
                show: false,
                title: "",
                data: {
                    id: null,
                    name: "", //学校名称
                    year: "", //年份
                    provice: "", //省份
                    cityName: "", //城市名称
                    schoolType: "", //所属院系
                    company: "", //合作企业
                    jobSatisfaction: "", //就业满意度
                    jobRate: "", //就业率
                    schoolSatisfaction: "", //母校满意度
                    employerSatisfaction: "", //雇主满意度
                },
                rules: {
                    name: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
                },
            },
            formItemGroup: [
                {
                    option: "input",
                    prop: "name",
                    label: "学校名称",
                    placeholder: "请输入",
                },
                {
                    option: "yeartime",
                    prop: "year",
                    label: "年份",
                    placeholder: "选择年份",
                },
                {
                    option: "select",
                    prop: "provice",
                    label: "省份",
                    placeholder: "请选择",
                    selectList: [
                        "河北省",
                        "山西省",
                        "辽宁省",
                        "吉林省",
                        "黑龙江省",
                        "江苏省",
                        "浙江省",
                        "安徽省",
                        "福建省",
                        "江西省",
                        "山东省",
                        "河南省",
                        "湖北省",
                        "湖南省",
                        "广东省",
                        "海南省",
                        "四川省",
                        "贵州省",
                        "云南省",
                        "陕西省",
                        "甘肃省",
                        "青海省",
                        "北京",
                        "天津",
                        "上海",
                        "重庆",
                    ],
                },
                {
                    option: "input",
                    prop: "cityName",
                    label: "城市名称",
                    placeholder: "请输入",
                },
                {
                    option: "input",
                    prop: "schoolType",
                    label: "所属院系",
                    placeholder: "请输入",
                },
                {
                    option: "input",
                    prop: "company",
                    label: "合作企业",
                    placeholder: "请输入",
                },
                {
                    option: "textarea",
                    prop: "jobSatisfaction",
                    label: "就业满意度",
                    placeholder: "请输入",
                },
                {
                    option: "input",
                    prop: "jobRate",
                    label: "就业率",
                    placeholder: "请输入",
                },
                {
                    option: "textarea",
                    prop: "schoolSatisfaction",
                    label: "母校满意度",
                    placeholder: "请输入",
                },
                {
                    option: "textarea",
                    prop: "employerSatisfaction",
                    label: "雇主满意度",
                    placeholder: "请输入",
                },
            ],
        };
    },
    watch: {
        "specialtyBox.data.filterText"(val) {
            console.log(val);
            this.$refs.specialtyTree.filter(val);
        },
    },
    created() {
        this.search();
    },
    mounted() {
        // 初始化
        this.uploadBox.show = false;
        this.$store.commit("modifyVague", false);
    },
    methods: {
        // 查询表格
        search(page) {
            this.searchData.pageDto.pageNum = page ? page : 1;
            this.tableObj.jumpTo = page ? page : 1;
            this.$axios
                .post(this.$apiurls.account_getSchoolList, this.searchData, {
                    loading: false,
                })
                .then(res => {
                    console.log("查询", res);
                    if (res) {
                        for (let i = 0; i < res.data.list.length; i++) {
                            if (this.searchData.pageDto.pageNum == 1) {
                                res.data.list[i].index = i + 1;
                            } else {
                                res.data.list[i].index =
                                    i + 1 + (this.searchData.pageDto.pageNum - 1) * 10;
                            }
                            res.data.list[i].status = res.data.list[i].status == 0 ? false : true;
                        }
                        this.tableObj.list = res.data.list;
                        this.tableObj.total = res.data.total;
                    }
                });
        },
        // 重置表格
        reset() {
            this.searchData.name = "";
            this.search();
        },
        // 点击编辑按钮
        edit(row) {
            this.optId = "2";
            this.uploadBox.title = "修改院校";
            this.uploadBox.show = true;
            this.$store.commit("modifyVague", true);
            for (const key in this.uploadBox.data) {
                this.uploadBox.data[key] = row[key];
            }
        },
        // 点击删除按钮
        cutOut(id) {
            this.$store.commit("modifyVague", true);
            this.$confirm("此操作将永久删除该院校, 是否继续?", "删除提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "error",
            })
                .then(() => {
                    this.$axios
                        .post(
                            this.$apiurls.account_delSchoolInfo,
                            { id },
                            {
                                loading: false,
                            }
                        )
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.search();
                            }
                            this.uploadBox.show = false;
                            this.$store.commit("modifyVague", false);
                        });
                })
                .catch(() => {
                    this.uploadBox.show = false;
                    this.$store.commit("modifyVague", false);
                });
        },
        // 点击新增按钮
        add() {
            // 每次新增打开弹框前都先清除之前的表单数据
            for (const key in this.uploadBox.data) {
                if (key === "id") this.uploadBox.data[key] = null;
                else this.uploadBox.data[key] = "";
            }
            this.optId = "1";
            this.uploadBox.title = "添加院校";
            this.uploadBox.show = true;
            this.$store.commit("modifyVague", true);
        },
        // 关闭弹框
        handleClose() {
            this.uploadBox.show = false;
            this.$store.commit("modifyVague", false);
            this.optId = "";
        },
        // 添加/修改院校请求接口
        submitUpload() {
            this.$refs.uploadBox.validate(valid => {
                if (valid) {
                    console.log(this.uploadBox.data);
                    let url =
                        this.optId === "1"
                            ? this.$apiurls.account_addSchoolInfo
                            : this.optId === "2"
                            ? this.$apiurls.account_editSchoolInfo
                            : "";
                    if (!url) return;
                    this.$axios
                        .post(url, this.uploadBox.data, {
                            loading: false,
                        })
                        .then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: this.optId === "2" ? "编辑成功！" : "添加成功！",
                                    type: "success",
                                });
                                this.search();
                            }
                            this.uploadBox.show = false;
                            this.$store.commit("modifyVague", false);
                            this.optId = "";
                        });
                }
            });
        },
        // 弹框打开
        opened() {
            // 每次打开弹框都清空校验
            this.$refs.uploadBox.clearValidate();
        },
    },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.addition{
  margin-top: 5px;
}
// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}
.el-form {
    height: 100%;
}
// 分配专业
.distribute ::v-deep .el-dialog__body {
    padding: 10px 20px 20px;
}
.distributionBox {
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: 10px;
}
.specialty_box {
    height: 470px;
    overflow-y: auto;
    // background: #a5a4bf;
    margin-bottom: 60px;
    margin-right: 20px;
}
.specialty_bottom {
    position: absolute;
    bottom: -45px;
    right: 38%;
}
.el-tree,
::v-deep.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content,
::v-deep.el-tree-node:focus > .el-tree-node__content {
    background: transparent;
    color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
    background: #203058 !important;
    color: #fff;
}
</style>
